/**
 * Returns a new array sorted by a string property (case-insensitive).
 * Does not mutate the original array.
 *
 * @param {Array} array - Array to sort
 * @param {string|function} keyOrGetter - Property name (e.g. 'companyContact', 'name') or function(item) => string
 * @returns {Array} New sorted array
 */
function sortByString(array, keyOrGetter) {
    if (!Array.isArray(array) || array.length <= 1) {
        return array ? [...array] : [];
    }
    const getValue = typeof keyOrGetter === 'function'
        ? (item) => (keyOrGetter(item) ?? '').toString().toLowerCase()
        : (item) => (item?.[keyOrGetter] ?? '').toString().toLowerCase();
    return array.slice().sort((a, b) => {
        const nameA = getValue(a);
        const nameB = getValue(b);
        return nameA.localeCompare(nameB);
    });
}

export { sortByString };
